<template>
  <div>
    <mobialis-form-with-validation
      @onValidate="handleSubmit"
      v-av-analytics-form-submit="{ elementText: $t('message.common.mobileVerification.sendCode') }"
      novalidate
    >
      <h2 class="mb-3 mt-sm-4">
        {{ $t('message.common.mobileVerification.title') }}
      </h2>
      <p class="mb-4">
        {{ $t('message.trade.mobileVerification.text') }}
      </p>
      <div class="row">
        <div class="col-sm-6">
          <mobialis-text-input-with-validation
            rules="required|length:10"
            :label="
              isPrefilled
                ? $t('message.common.mobileVerification.labelTitle')
                : $t('message.common.mobileVerification.enterMobileVerification')
            "
            v-model="localPhoneNumber"
            vid="phoneNumber"
            mask-type="phoneNumber"
            type="tel"
            data-cy="phoneNumber"
          />
        </div>
      </div>
      <mobialis-button type="submit" class="verifyButton" data-cy="verifyNumber">
        {{ $t('message.common.mobileVerification.sendCode') }}
      </mobialis-button>
    </mobialis-form-with-validation>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import log from '@/services/log';

export default {
  name: 'VerifyPhoneNumberForm',
  data() {
    return {
      localPhoneNumber: '',
      isPrefilled: false,
    };
  },
  computed: {
    ...mapGetters({
      leadId: 'lead/getLeadId',
    }),
  },
  mounted() {
    if (this.$store.state.user.phoneNumber) {
      this.localPhoneNumber = this.$store.state.user.phoneNumber;
      this.isPrefilled = true;
    }
  },
  methods: {
    async handleSubmit(isValid) {
      if (!isValid) return;
      try {
        this.$store.commit('SET_LOADING', true);
        this.$store.commit('user/SET_PHONE_NUMBER', this.localPhoneNumber);
        await this.$store.dispatch('user/sendVerificationCode', this.leadId);
        this.$emit('form-successfully-submitted');
      } catch (error) {
        log('Error in sending verification code:', error);
        this.$emit('form-unsuccessfully-submitted');
      } finally {
        this.$store.commit('SET_LOADING', false);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.verifyButton {
  // smaller margin for mobile
  margin-top: 120px;

  // original margin for larger screens
  @media (min-width: 576px) {
    margin-top: 285px;
  }
}
</style>
